import {
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID,
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID,
  SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53
} from '@portal/config/base';
import { storeCodeSchema } from '@portal/schema/storeCode';

export const isDoubleSubscription = (
  store: keyof typeof storeCodeSchema.enum,
  variantId: string
) => {
  return (
    variantId === SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID[store].default ||
    variantId === SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID[store].freeShipping ||
    variantId === SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53[store].default ||
    variantId === SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53[store].tropical ||
    variantId === SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53[store].default ||
    variantId === SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53[store].tropical ||
    variantId === SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID[store].default ||
    variantId === SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID[store].freeShipping
  );
};
